// extracted by mini-css-extract-plugin
module.exports = {"root":"ExpiredStatus_root__U1lKu"};